<template>
  <div>
    <h1 class="box-h">{{ dataSource.Description }}</h1>
    <h2 class="box-h"></h2>
    <div class="m-slide-section">
      <div class="title">
        <div>
            <h4 class="box-h">
              <icon class="check-o" name="check-circle-o" /> Step 1:         
            </h4>
        </div>
        <div class="title-desc"> 
            <div class="title-detail"><h4 class="box-h">Select Target Area(s)</h4></div>
            <div class="title-icon">
              <b-link @click="goGeo" class="title-edit">     
                <icon name="pencil" />
              </b-link>
            </div>
        </div>
      </div>
      <m-slide-item :items="geos" :canDelete="false" />
    </div>

    <div class="m-slide-section">
      <div class="title">
        <div>
            <h4 class="box-h">
              <icon class="check-o" name="check-circle-o" /> Step 2:     
            </h4>
        </div>
        <div class="title-desc"> 
            <div class="title-detail">
              <h4 class="box-h">Define Target Audience
              </h4>
            </div>
            <div class="title-icon">
              <b-link @click="goDemo" class="title-edit">
                <icon name="pencil" />
              </b-link>
            </div>
        </div>
      </div>
      <m-slide-item :items="demos" :canDelete="false" />
    </div>

    <div class="m-slide-section">
        <div>
            <h4 class="box-h">
              <icon class="check-o" name="check-circle-o" /> Step 3:   
            </h4>
        </div>
        <div class="title-desc"> 
            <div class="title-detail">
              <h4 class="box-h">Review Count & Order
              </h4>
            </div>
        </div>
      <div class="title item">
        Total Records:
        <span class="title-edit">
          {{ order.TotalDesiredQty | numberFormat("", 0) }}
        </span>
      </div>

      <!--<p class="item" v-if="$store.getters['summary/bonusPoint'] > 0">Earned Bonus Points:-->
      <!--<span class="color-primary">{{$store.getters['summary/bonusPoint'] | numberFormat('', 0)}}</span></p>-->
      <p class="title item-amound">
        Order Total:
        <span class="primary"
          >{{ order.TotalEstmCost | numberFormat }} + Tax</span
        >
      </p>
      <!--<p class="item">-->
      <!--{{site.termsBrief}}-->
      <!--</p>-->
    </div>
  </div>
</template>

<script>
import MSlideItem from "@/components/slide/MSlideItem.vue";

export default {
  components: {
    MSlideItem,
  },
  data() {
    return {
      geoTitle: {
        zip: "Zip Codes",
      },
    };
  },
  computed: {
    order() {
      return this.$store.state.order;
    },
    site() {
      return this.$store.state.site;
    },
    demos() {
      return this.$store.getters["order/demos"];
    },
    geos() {
      return this.$store.getters["order/geos"];
    },
    currentGeoType() {
      return this.$store.getters["order/currentGeoType"];
    },
    dataSource() {
      return this.$store.getters["config/datasource"];
    },
  },
  methods: {
    goDemo() {
      this.$router.push({ name: "demo" });
    },
    goGeo() {
      if (this.currentGeoType.routeName) {
        this.$router.push({ name: "geo" });
      } else {
        let geoType = this.currentGeoType.name;
        if (this.currentGeoType.title === "Radius Around an Address") {
          geoType = "radius";
        }
        this.$router.push({ name: "geo-" + geoType });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.box-h {
  color: $color-white;
}

.check-o {
  color: $color-primary;
}

.item {
  margin-bottom: 8px;
}

.title {
  display: flow;
  justify-content: space-between;
}

.title-desc {
  display: flex;
}

.title-detail {
  width: 90%;
}

.title-icon {
  width: 10%;
  text-align: right;
}

.title-edit {
  margin-left: 16px;
}

.item {
  margin-top: 8px;
  color: $color-white;
}
.item-amound {
  margin-top: 8px;
  color: $color-white;
}
</style>



// WEBPACK FOOTER //
// src/components/slide/MSlideSummary.vue